import addExternalCarrierTrackingReferenceCommand from './addExternalCarrierTrackingReferenceCommand';
import createContextIfNotExistCommand from './createContextIfNotExistCommand';
import createFileAttachmentsFromControlCommand from './createFileAttachmentsFromControlCommand';
import createTechnicalIntervention from './createTechnicalIntervention';
import createWorkOrderCommand from './createWorkOrderCommand';
import deleteFileAttachmentCommand from './deleteFileAttachmentCommand';
import explodeFileCommand from './explodeFileCommand';
import forceCloseFileCommand from './forceCloseFileCommand';
import { getDefaultWorkTypeQuery } from './getDefaultWorkTypeQuery';
import { getFileAdditionalInformationQuery } from './getFileAdditionalInformationQuery';
import { getFileAttachmentUploadLinkFromControlCommand } from './getFileAttachmentUploadLinkFromControlCommand';
import { getFileAttachmentUploadLinkFromMyAccountCommand } from './getFileAttachmentUploadLinkFromMyAccountCommand';
import getFileHandling from './getFileHandling';
import getFileRiskCarrier from './getFileRiskCarrier';
import { getFileStatesQuery } from './getFileStatesQuery';
import getFilesForProductsCommand from './getFilesForProductsCommand';
import getSalesforceContextQuery from './getSalesforceContextQuery';
import { getShortFileInfoQuery } from './getShortFileInfoQuery';
import { listFileAttachmentsFromControlQuery } from './listFileAttachmentsFromControlQuery';
import getTechnicalInterventionQuery from './getTechnicalInterventionQuery';
import getTechnicalInterventionTimeSlots from './getTechnicalInterventionTimeSlots';
import { getUserActionsQuery } from './getUserActionsQuery';
import getWorkTypeBySellerQuery from './getWorkTypeBySellerQuery';
import oldGetTechnicalInterventionTimeSlots from './oldGetTechnicalInterventionTimeSlots';
import refreshFileCommand from './refreshFileCommand';
import renameFileAttachmentCommand from './renameFileAttachmentCommand';
import setCommercialSolutionCommand from './setCommercialSolutionCommand';
import setDevicePasswordCommand from './setDevicePasswordCommand';
import { setFileAdditionalInformationWithFilesAndTokenCommand } from './setFileAdditionalInformationWithFilesAndTokenCommand';
import setFileAttachmentInfo from './setFileAttachmentInfo';
import setUserActionAsyncCommand from './setUserActionAsyncCommand';
import splitFileAlongSolutionsCommand from './splitFileAlongSolutionsCommand';
import splitFileCommand from './splitFileCommand';
import updateFileOutcomeCommand from './updateFileOutcomeCommand';
import { upsertBankAccountDetails } from './upsertBankAccountDetails';

export const CommonWorkflowService = {
  getDefaultWorkTypeQuery,
  getTechnicalInterventionQuery,
  createContextIfNotExistCommand,
  createTechnicalIntervention,
  createWorkOrderCommand,
  getSalesforceContextQuery,

  getTechnicalInterventionTimeSlots,
  oldGetTechnicalInterventionTimeSlots,

  getWorkTypeBySellerQuery,
  getFileAdditionalInformationQuery,
  setUserActionAsyncCommand,
  upsertBankAccountDetails,
  getUserActionsQuery,
  getFileStatesQuery,

  getFileAttachmentUploadLinkFromControlCommand,
  getFileAttachmentUploadLinkFromMyAccountCommand,
  getShortFileInfoQuery,
  listFileAttachmentsFromControlQuery,
  setFileAdditionalInformationWithFilesAndTokenCommand,
  getFileHandling,
  deleteFileAttachmentCommand,
  renameFileAttachmentCommand,
  forceCloseFileCommand,
  updateFileOutcomeCommand,
  setFileAttachmentInfo,
  createFileAttachmentsFromControlCommand,
  getFileRiskCarrier,
  setDevicePasswordCommand,
  setCommercialSolutionCommand,
  addExternalCarrierTrackingReferenceCommand,
  splitFileCommand,
  explodeFileCommand,
  splitFileAlongSolutionsCommand,
  getFilesForProductsCommand,
  refreshFileCommand,
};
